import './index.scss';

export default class WidgetTabs {
  constructor(root) {
    this.root = root;

    this.items = this.root.querySelectorAll('.tabs-item');
    this.items.forEach((item) => { this.initItem(item); });

    this.links = this.root.querySelectorAll('.tabs-link');
    this.links.forEach((link) => { this.initLink(link); });
  }

  // Items

  initItem(item) {
    const link = item.querySelector('.tabs-head');
    const pane = item.querySelector('.tabs-pane');

    link.addEventListener('click', (event) => {
      event.preventDefault();

      if (item.classList.contains('opened')) {
        item.classList.remove('opened');
        pane.style.maxHeight = null;
      } else {
        this.closeAllItems();

        item.classList.add('opened');
        pane.style.maxHeight = pane.scrollHeight + 'px';
      }
    });
  }

  closeAllItems() {
    this.items.forEach((item) => {
      const pane = item.querySelector('.tabs-pane');

      if (item.classList.contains('opened')) {
        item.classList.remove('opened');
        pane.style.maxHeight = null;
      }
    });
  }

  // Links

  initLink(link) {
    link.addEventListener('click', (event) => {
      if (!link.classList.contains('active')) {
        this.closeAllLinks();

        link.classList.add('active');
        let item = document.querySelector('#' + link.dataset.target);
        if (item) { item.classList.add('active'); }
      }
    });
  }

  closeAllLinks() {
    this.links.forEach((link) => { link.classList.remove('active'); });
    this.items.forEach((item) => { item.classList.remove('active'); });
  }
}
